import { computed, makeObservable } from 'mobx'

import asyncAction from 'modules/core/lib/asyncAction'
import { Model } from 'modules/core/lib/mobx-rest'

import { triggers } from 'modules/automations/store/collections/triggers'
import type { Trigger } from 'modules/automations/store/models/Trigger'

export interface IAutomation {
  id: number
  name: string
  slug?: string
  enabled: boolean
  trigger: string
  company_id: number
  access_id: number
  is_readonly: boolean
  repeat_data?: string
  conflict_keys: Array<{
    key: string
    label: string
  }>
}

export class Automation extends Model<IAutomation> {
  constructor(attr: IAutomation) {
    super(attr)
    makeObservable(this, {
      trigger: computed,
      isDefault: computed,
      isEnabled: computed,
      isReadonly: computed,
    })
  }

  static urlRoot() {
    return '/automations/automations'
  }

  get id(): number {
    return this.attributes.id
  }

  get trigger(): Trigger | null | undefined {
    if (!this.has('trigger')) return

    return triggers.find({
      slug: this.attributes.trigger,
    })
  }

  get isDefault(): boolean {
    return !!this.attributes.slug
  }

  get isEnabled(): boolean {
    return !!this.attributes.enabled
  }

  get isReadonly(): boolean {
    return this.attributes.is_readonly
  }

  async activate(enable: boolean) {
    const { value, success } = await asyncAction(() => this.rpc('toggle', { enabled: enable }))

    if (success) {
      this.set(value)
    }
  }

  async toggleActivation() {
    this.activate(!this.isEnabled)
  }
}
